import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Parcel } from 'src/app/_models/parcel';

@Component({
    selector: 'app-district-offices',
    templateUrl: './district-offices.component.html',
    styleUrls: ['./district-offices.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DistrictOfficesComponent implements OnInit {
  parcel: Parcel;
  selector = true;
  constructor() { }

  ngOnInit() {
  }
  getAddress(event: Parcel) {
    console.log(event);
    this.parcel = event;
  }

}
